import vibrationAnalyzeReportService from '../service/vibrationAnalyzeReport'

const state =
{
    reportsLoading: false,
    searchResult: {
        total: 0,
        reports: [],
    }
};

const actions = {
   
    getVibrationAnalyzeReports({ commit },{pointId,query}) {
        commit('setLoading', true)
        return vibrationAnalyzeReportService.getVibrationAnalyzeReports(pointId, query).then(reports => {
            commit('setReports', reports)
        }).finally(() =>
            commit('setLoading', false)
        )
    },

};
const mutations = {

    setLoading(state, bool) {
        state.reportsLoading = bool
    },
    setReports(state, reports) {
        state.searchResult = reports
        state.reportsLoading = false
    },
   

};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
